import script from "./TransferLeadsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferLeadsModal.vue?vue&type=script&setup=true&lang=js"

import "./TransferLeadsModal.vue?vue&type=style&index=0&id=0df5294c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df5294c"]])

export default __exports__